// extracted by mini-css-extract-plugin
module.exports = {"hashLink":"Link_hashLink__nRXTb","inactive":"Link_inactive__py9n_"};